import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { QrCode, LogOut, LayoutDashboard } from 'lucide-react';
import { InBooks24Logo } from './InBooks24Logo';
import { useAuth } from '../contexts/AuthContext';
import { useBranch } from '../contexts/BranchContext';

/**
 * Lightweight post-login mobile home: Scan RM CTA (no ERP sidebar).
 */
export function RmMobileHomePage() {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const { selectedBranch } = useBranch();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-primary-50 to-white flex flex-col">
      <header className="flex items-center justify-between px-4 py-3 border-b border-primary-100 bg-white/80 backdrop-blur">
        <InBooks24Logo size="sm" variant="horizontal" showTagline={false} />
        <Button variant="ghost" size="sm" onClick={handleLogout} className="text-gray-600">
          <LogOut className="h-4 w-4 mr-1" />
          Logout
        </Button>
      </header>

      <main className="flex-1 flex flex-col items-center justify-center px-6 py-10 gap-8">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-bold text-primary-900">RM Lookup</h1>
          <p className="text-sm text-gray-600">
            {user?.displayName || user?.username
              ? `Signed in as ${user.displayName || user.username}`
              : 'Scan a raw material QR label'}
          </p>
          {selectedBranch != null && (
            <p className="text-xs text-gray-500">Branch ID: {selectedBranch}</p>
          )}
        </div>

        <Button
          size="lg"
          className="w-full max-w-sm h-16 text-lg bg-primary-600 hover:bg-primary-700 text-white shadow-lg"
          onClick={() => navigate('/raw-items/scanner')}
        >
          <QrCode className="h-6 w-6 mr-3" />
          Scan RM
        </Button>

        <Button
          variant="outline"
          className="w-full max-w-sm border-primary-200 text-primary-700"
          onClick={() => navigate('/dashboard')}
        >
          <LayoutDashboard className="h-4 w-4 mr-2" />
          Open full app
        </Button>
      </main>
    </div>
  );
}
